import { defaultTRYOCameraOrbit } from "../enums/constants"
import { ModelCategories } from "../enums/modelCategories"

export const cameraOrbitHelper = (category: string): string => {
    if(category === ModelCategories.EYEWEAR || category === ModelCategories.HATS || category === ModelCategories.SHOES){
        return defaultTRYOCameraOrbit
    }else {
        return "auto auto auto"
    }
}